export default {
  title: 'لیست دانش آموزان',
  search:'جستجو ...',
  id: 'شناسه',
  name : 'نام',
  mobile:'شماره موبایل',
  lastLogin: 'آخرین لاگین',
  CreatedAt: 'زمان ایجاد',
  status: 'وضعیت',
  statusActive: 'فعال',
  statusInActive: 'غیرفعال',
  loading:'در حال دریافت اطلاعات ...',
  operating:'عملیات',
  empty:'داده ای یافت نشد',
  success:'موفق',
  next: 'بعدی',
  previous: 'قبلی',
  deleteConfirm:'آیا از حذف این کاربر مطمئن هستید؟'




}
